module.exports = "/static/assets/0e838120838e2bea2f8b5dec332a5a68.png";